<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-04 10:32:13
 * @Description: 账号激活
-->
<template>
	<div class="active_main">
		<a-steps :current="current">
			<a-step v-for="item in steps" :key="item.title" :title="item.title" />
		</a-steps>
		<div class="steps-content">
			<component
				:basicSetInfo="basicSetInfo"
				:is="steps[current]['comp']"
				@next="(val) => (current = val)"
				@success="() => $emit('success')"
			></component>
		</div>
	</div>
</template>
<script>
import Infocheck from "./components/Infocheck"; // 信息校验
import Bandemail from "./components/Bandemail"; // 绑定邮箱
import Setpass from "./components/Setpass"; // 设置密码
import Success from "./components/Success"; // 激活成功

export default {
	components: { Infocheck, Bandemail, Setpass, Success },
	props: {
		basicSetInfo: { type: Object, default: () => {} },
	},
	data() {
		return {
			current: 0,
			steps: [
				{ title: this.$t("login.activate.step_one"), comp: "Infocheck" },
				{ title: this.$t("login.activate.step_two"), comp: "Bandemail" },
				{ title: this.$t("login.activate.step_three"), comp: "Setpass" },
				{ title: this.$t("login.activate.step_four"), comp: "Success" },
			],
		};
	},
	methods: {},
};
</script>
<style scoped lang="less">
.active_main {
	padding: 30px 30px 40px;

	.steps-content {
		margin-top: 45px;
	}
}
</style>
